function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcRisk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 68",
    id: "risk-management",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    fill: "#010101",
    d: "m66.1 29.4-7-.9c-.7-3-1.8-5.8-3.5-8.4l4.2-5.5c.3-.5.3-1.1-.1-1.5l-5-5c-.4-.4-.9-.4-1.3-.1l-5.6 4.3c-2.6-1.6-5.4-2.8-8.4-3.5l-.9-7c-.1-.5-.5-.9-1-.9h-7.2c-.5 0-.9.4-1 .9l-.9 7c-3 .7-5.8 1.8-8.4 3.5L14.5 8c-.4-.3-1-.3-1.3.1l-5.1 5.1c-.4.4-.4.9-.1 1.3l4.3 5.6c-1.6 2.6-2.8 5.4-3.5 8.4l-7 .9c-.5.1-.9.5-.9 1v7.2c0 .5.4.9.9 1l7 .9c.7 3 1.8 5.8 3.5 8.4L8 53.5c-.3.4-.3 1 .1 1.3l5.1 5.1c.4.4.9.4 1.3.1l5.6-4.3c2.6 1.6 5.4 2.8 8.4 3.5l.9 7c.1.5.5.9 1 .9h7.2c.5 0 .9-.4 1-.9l.9-7c3-.7 5.8-1.8 8.4-3.5l5.5 4.2c.2.1.5.2.7.2.3 0 .6-.1.8-.3l5-5c.4-.4.4-.9.1-1.3l-4.3-5.6c1.6-2.6 2.8-5.4 3.5-8.4l7-.9c.5-.1.9-.5.9-1v-7.2c-.1-.5-.5-.9-1-1zM65 36.7l-6.8.9c-.4.1-.8.4-.9.8-.6 3.2-1.9 6.2-3.7 8.9-.2.4-.2.8 0 1.2l4.2 5.4-3.8 4-5.4-4.2c-.3-.3-.8-.3-1.2 0-2.7 1.8-5.7 3.1-8.9 3.7-.4.1-.7.4-.8.9l-1 6.7h-5.5l-.9-6.8c-.1-.4-.4-.8-.8-.9-3.2-.6-6.2-1.9-8.9-3.7-.4-.2-.8-.2-1.2 0L14 57.9 10.1 54l4.1-5.4c.3-.4.3-.9 0-1.3-1.8-2.7-3-5.6-3.6-8.8-.1-.4-.4-.7-.9-.8l-6.7-1v-5.5l6.8-.9c.4-.1.8-.4.9-.8.6-3.2 1.9-6.2 3.7-8.9.2-.4.2-.8 0-1.2L10.1 14l3.9-3.9 5.4 4.1c.2.2.4.2.7.2.2 0 .5-.1.6-.2 2.7-1.8 5.6-3 8.8-3.6.4-.1.7-.4.8-.9l1-6.7h5.5l.9 6.8c.1.4.4.8.8.9 3.2.6 6.2 1.9 8.9 3.7.4.2.8.2 1.2 0l5.4-4.2 3.9 3.9-4.2 5.4c-.3.3-.3.8 0 1.2 1.8 2.7 3.1 5.7 3.7 8.9.1.4.4.7.9.8l6.8.9v5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    fill: "#010101",
    d: "M34 15.5c-10.2 0-18.5 8.3-18.5 18.5S23.8 52.5 34 52.5 52.5 44.2 52.5 34 44.2 15.5 34 15.5zm0 35c-9.1 0-16.5-7.4-16.5-16.5S24.9 17.5 34 17.5 50.5 24.9 50.5 34 43.1 50.5 34 50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    fill: "#010101",
    d: "M34 19c-.8 0-1.5.4-1.9 1.2L21.8 39.8c-.4.7-.3 1.5.1 2.1.4.7 1.1 1 1.8 1h20.7c.8 0 1.5-.4 1.8-1 .4-.7.4-1.5.1-2.1L35.9 20.2c-.4-.7-1.1-1.2-1.9-1.2zm10.5 21.9c0 .1-.1.1-.1.1H23.7s-.1 0-.1-.1v-.2l10.3-19.6s0-.1.1-.1.1.1.1.1l10.3 19.6c.1.1.1.1.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    fill: "#010101",
    d: "M34 36.4c-.5 0-.9.2-1.2.5-.3.3-.5.7-.5 1.2s.2.9.5 1.2c.3.3.7.5 1.2.5s.9-.2 1.2-.5c.3-.3.5-.7.5-1.2s-.2-.9-.5-1.2c-.3-.3-.7-.5-1.2-.5zM32.3 28.6l.6 6.9h2.2l.6-6.9v-2.4h-3.4z"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcRisk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-risk.7e50c8bdf20206081e7c9d44f3e2ff51.svg";